import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Image } from "react-bootstrap";
import { Bar, Line } from "react-chartjs-2"; // Import Bar and Line charts for localization metrics
import axios from "axios";
import { Chart, registerables } from "chart.js";

// Register all necessary Chart.js components
Chart.register(...registerables);

const Localization = () => {
  const [packageName, setPackageName] = useState("");
  const [localizationData, setLocalizationData] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "http://localhost:8000/api/google-scraper/localization/",
        {
          package_name: packageName,
        }
      );
      setLocalizationData(response.data);
      setError(null);
    } catch (err) {
      setError("An error occurred while fetching the localization data.");
      setLocalizationData(null);
    }
  };

  const renderLocalizationData = () => {
    if (!localizationData) return null;

    // Prepare chart data for Installs
    const installsData = {
      labels: ["Installs"],
      datasets: [
        {
          label: "Total Installs",
          backgroundColor: "#007bff",
          data: [parseInt(localizationData.installs.replace(/,/g, ''), 10) || 0],
        },
      ],
    };

    // Prepare chart data for Ratings
    const ratingsData = {
      labels: ["Rating"],
      datasets: [
        {
          label: "Average Rating",
          backgroundColor: "#28a745",
          data: [localizationData.rating || 0],
        },
      ],
    };

    return (
      <div>
        <h2 className="my-4 text-center">Localization Results</h2>

        {/* Displaying App Icon and Title */}
        <Row className="mb-4 text-center">
          <Col>
            <Image src={localizationData.icon_url} roundedCircle width="100" />
            <h4>{localizationData.title}</h4>
            <p><strong>Description:</strong> {localizationData.description}</p>
          </Col>
        </Row>

        {/* Displaying Metrics as Charts */}
        <Row className="mb-4">
          <Col md={6} className="mb-4">
            <Card>
              <Card.Body>
                <h5 className="text-center">Installs Overview</h5>
                <Bar data={installsData} options={{ responsive: true }} />
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card>
              <Card.Body>
                <h5 className="text-center">Ratings Overview</h5>
                <Line data={ratingsData} options={{ responsive: true }} />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Additional Information */}
        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <h5>Additional Info</h5>
                <p><strong>Developer:</strong> {localizationData.developer || "N/A"}</p>
                <p><strong>Genre:</strong> {localizationData.genre || "N/A"}</p>
                <p><strong>Installs:</strong> {localizationData.installs || "N/A"}</p>
                <p><strong>Ratings:</strong> {localizationData.rating || "N/A"}</p>
                <p><strong>Screenshots:</strong></p>
                <Row className="text-center">
                  {localizationData.screenshots && localizationData.screenshots.length > 0 ? (
                    localizationData.screenshots.map((screenshot, index) => (
                      <Col md={4} key={index} className="mb-4">
                        <Card>
                          <Card.Img variant="top" src={screenshot} />
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <Col>
                      <p>No screenshots available.</p>
                    </Col>
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Container className="mt-5">
      <Form onSubmit={handleSubmit}>
        <Row className="justify-content-center">
          <Col md={8}>
            <Form.Group controlId="packageName">
              <Form.Label>Enter the App Package Name:</Form.Label>
              <Form.Control
                type="text"
                placeholder="com.example.app"
                value={packageName}
                onChange={(e) => setPackageName(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={4} className="align-self-end">
            <Button type="submit" className="btn btn-primary mt-2">
              Fetch Localization Data
            </Button>
          </Col>
        </Row>
      </Form>

      {/* Error Message */}
      {error && (
        <div className="alert alert-danger text-center mt-4">{error}</div>
      )}

      {/* Displaying Localization Data */}
      {localizationData && renderLocalizationData()}
    </Container>
  );
};

export default Localization;
